import { render } from "./IncomeStatement.vue?vue&type=template&id=52198977&scoped=true&ts=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=ts"
export * from "./IncomeStatement.vue?vue&type=script&lang=ts"

import "./IncomeStatement.vue?vue&type=style&index=0&id=52198977&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52198977"]])

export default __exports__